"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
class FileUploaderFile {
  #id;
  #file;
  #base64;
  constructor(id, file, base64) {
    this.id = id;
    this.file = file;
    this.base64 = base64;
  }
  getId() {
    return this.id;
  }
  getName() {
    return this.file.name;
  }
  getOriginalFile() {
    return this.file;
  }
  getBase64() {
    return this.base64;
  }
}
exports.default = FileUploaderFile;